import React, { useState, useEffect } from 'react';
import NotLoggedInRedirection from '../Auth/NotLoggedInRedirection/NotLoggedInRedirection';
import { Link } from 'react-router-dom';
import NFTItem from '../Layouts/NFTItem/NFTItem';
import OrderCard from './OrderCard';
import OrderCardSkeleton from './OrderCardSkeleton';
import { getActiveOrders, getCancelOrders, getCloseOrders, } from '../../api/nft/nft';
import LoadMoreSection from '../Common/LoadMoreSection';
import "./MyItem.css"
import LoadingError from '../ItemDetail/Comment/LoadingError';
export default function MyItems() {


    //loading state

    const [activeOrderLoading, setActiverOrderLoading] = useState(true)
    const [closeOrderLoading, setCloseOrderLoading] = useState(false)
    const [cancelOrderLoading, setCancelOrderLoading] = useState(false)
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    //data error
    const [activeOrderError, setActiveOrderError] = useState(null);
    const [closeOrderError, setCloseOrderError] = useState(null);
    const [cancelOrderError, setCancelOrderError] = useState(null);
    //data state
    const [activeOrderList, setActiveOrderList] = useState([])
    const [closeOrderList, setCloseOrderList] = useState([])
    const [cancelOrderList, setCancelOrderList] = useState([])
    //data pagination object
    const [activeOrderPagination, setActiveOrderPagination] = useState({})
    const [closeOrderPagination, setCloseOrderPagination] = useState({})
    const [cancelOrderPagination, setCancelOrderPagination] = useState({})
    //default page
    const [activeOrderPage, setActiveOrderPage] = useState(1)
    const [closeOrderPage, setCloseOrderPage] = useState(1)
    const [cancelOrderPage, setCancelOrderPage] = useState(1)
    //cover image


    const fetchInitialData = async () => {
        try {
            await Promise.all([
                getActiveOrders(activeOrderPage)
                    .then(res => {
                        setActiveOrderList(res.data.data.orders);
                        setActiveOrderPagination(res.data.data.pagination);
                    })
                    .catch(() => { setActiveOrderError("Getting some issue to load listed item") }),

                getCloseOrders(closeOrderPage)
                    .then(res => {

                        setCloseOrderList(res.data.data.orders);
                        setCloseOrderPagination(res.data.data.pagination);
                    })
                    .catch(() => { setCloseOrderError("Getting some issue to load owned item") }),

                getCancelOrders(cancelOrderPage)
                    .then(res => {

                        setCancelOrderList(res.data.data.orders);
                        setCancelOrderPagination(res.data.data.pagination);
                    })
                    .catch(() => { setCancelOrderError("Getting some issue to load created item") })
            ]);
        } finally {
            setActiverOrderLoading(false);
            setCloseOrderLoading(false);
            setCancelOrderLoading(false);
        }
    };

    useEffect(() => {
        fetchInitialData();
    }, []);

    const fetchMoreActiveOrder = async page => {

        if (!activeOrderPagination?.has_next_page) return;
        try {
            setIsLoadingMore(true);
            const { data } = await getActiveOrders(page);
            const incoming = data?.data?.orders || [];
            const pagination = data?.data?.pagination || {};
            setActiveOrderList(prev => ([...prev, ...incoming]));
            setActiveOrderPagination({
                ...pagination,
                current_page: Number(pagination.current_page)
            })

        } finally {
            setIsLoadingMore(false);
        }
    };

    const fetchMoreCloseOrder = async page => {
        if (!closeOrderPagination?.has_next_page) return;
        try {
            setIsLoadingMore(true);
            const { data } = await getCloseOrders(page);
            const incoming = data?.data?.orders || [];
            const pagination = data?.data?.pagination || {};
            setCloseOrderList(prev => [...prev, ...incoming]);
            setCloseOrderPagination({
                ...pagination,
                current_page: Number(pagination.current_page)
            })
        } finally {
            setIsLoadingMore(false);
        }
    };

    const fetchMoreCancelOrder = async page => {
        if (!cancelOrderPagination?.has_next_page) return;
        try {
            setIsLoadingMore(true);
            const { data } = await getCancelOrders(page);
            const incoming = data?.data?.orders || [];
            const pagination = data?.data?.pagination || {};
            setCancelOrderList(prev => [...prev, ...incoming]);
            setCancelOrderPagination({
                ...pagination,
                current_page: Number(pagination.current_page)
            })
        } finally {
            setIsLoadingMore(false);
        }
    };




    useEffect(() => {
        if (activeOrderPage > 1) fetchMoreActiveOrder(activeOrderPage);
    }, [activeOrderPage]);

    useEffect(() => {
        if (closeOrderPage > 1) fetchMoreCloseOrder(closeOrderPage);
    }, [closeOrderPage]);

    useEffect(() => {
        if (cancelOrderPage > 1) fetchMoreCancelOrder(cancelOrderPage);
    }, [cancelOrderPage]);

    const loadMoreActiveOrder = () => {
        if (activeOrderPagination?.has_next_page) setActiveOrderPage(prev => prev + 1);
    };

    const loadMoreCloseOrder = () => {
        if (closeOrderPagination?.has_next_page) setCloseOrderPage(prev => prev + 1);
    };

    const loadMoreCancelOrder = () => {
        if (cancelOrderPagination?.has_next_page) setCancelOrderPage(prev => prev + 1);
    };

    return (

        <main>
            <section id="ItemsProfile" className="py-5 BgGrey">
                <div className="container">
                    <div className='row' id='zIndexMob'>

                        <div className="TabBox">
                            <ul className="nav nav-tabs justify-content-center BorderBottom mb-4" id="myTab" role="tablist" style={{ marginTop: "100px" }}>
                                <li className="nav-item" role="presentation">
                                    <button

                                        className="nav-link active" id="Sale-tab" data-bs-toggle="tab" data-bs-target="#Sale" type="button" role="tab" aria-controls="Sale" aria-selected="true">Active Orders</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link" id="Owned-tab" data-bs-toggle="tab" data-bs-target="#Owned" type="button" role="tab" aria-controls="Owned" aria-selected="false">Closed Orders</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link" id="Created-tab" data-bs-toggle="tab" data-bs-target="#Created" type="button" role="tab" aria-controls="Created" aria-selected="false">Cancelled Orders</button>
                                </li>


                            </ul>
                            <div className="tab-content MarketDataCard" id="myTabContent">

                                <div className="tab-pane fade show active" id="Sale" role="tabpanel" aria-labelledby="Sale-tab">

                                    {activeOrderError && !activeOrderLoading ? (
                                        <div className="text-center py-5" style={{ maxWidth: '500px', margin: '120px auto', padding: '40px 20px' }}>
                                            {/* Error Icon Container */}
                                            <div style={{
                                                width: '140px',
                                                height: '140px',
                                                margin: '0 auto 32px',
                                                background: 'linear-gradient(135deg, rgba(239, 68, 68, 0.08), rgba(220, 38, 38, 0.08))',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                border: '3px solid rgba(239, 68, 68, 0.2)',
                                                position: 'relative'
                                            }}>
                                                <svg width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#ef4444', filter: 'drop-shadow(0 4px 16px rgba(239, 68, 68, 0.3))' }}>
                                                    <circle cx="12" cy="12" r="10"></circle>
                                                    <line x1="12" y1="8" x2="12" y2="12"></line>
                                                    <line x1="12" y1="16" x2="12.01" y2="16"></line>
                                                </svg>
                                            </div>
                                            
                                            {/* Error Title */}
                                            <h3 style={{ 
                                                color: '#1a1a1a', 
                                                marginBottom: '16px', 
                                                fontSize: '32px', 
                                                fontWeight: '700',
                                                lineHeight: '1.2',
                                                letterSpacing: '-0.5px'
                                            }}>
                                                Unable to Load Orders
                                            </h3>
                                            
                                            {/* Error Message */}
                                            <p style={{ 
                                                color: '#6b7280', 
                                                fontSize: '17px', 
                                                lineHeight: '1.7', 
                                                marginBottom: '0',
                                                fontWeight: '500',
                                                maxWidth: '420px',
                                                margin: '0 auto'
                                            }}>
                                                {'Something went wrong while fetching your active orders. Please try again later.'}
                                            </p>
                                        </div>
                                    ) : activeOrderLoading && activeOrderList.length === 0 ? (
                                        <div className="orders-grid">
                                            {new Array(6).fill(1).map((_, index) => (
                                                <OrderCardSkeleton key={index} />
                                            ))}
                                        </div>
                                    ) : !activeOrderLoading && activeOrderList.length === 0 ? (
                                        <div className="text-center py-5" style={{ maxWidth: '500px', margin: '120px auto', padding: '40px 20px' }}>
                                            {/* Icon Container */}
                                            <div style={{
                                                width: '140px',
                                                height: '140px',
                                                margin: '0 auto 32px',
                                                background: 'linear-gradient(135deg, rgba(17, 207, 243, 0.1), rgba(105, 239, 183, 0.1))',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                border: '3px solid rgba(17, 207, 243, 0.2)',
                                                position: 'relative',
                                                animation: 'iconFloat 3s ease-in-out infinite'
                                            }}>
                                                <div style={{
                                                    position: 'absolute',
                                                    top: '50%',
                                                    left: '50%',
                                                    transform: 'translate(-50%, -50%)',
                                                    width: '120%',
                                                    height: '120%',
                                                    background: 'radial-gradient(circle, rgba(17, 207, 243, 0.2) 0%, rgba(105, 239, 183, 0.15) 40%, transparent 70%)',
                                                    borderRadius: '50%',
                                                    animation: 'glowPulse 3s ease-in-out infinite'
                                                }}></div>
                                                <svg width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#11cff3', filter: 'drop-shadow(0 4px 16px rgba(17, 207, 243, 0.4))', position: 'relative', zIndex: 1 }}>
                                                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                                    <polyline points="14 2 14 8 20 8"></polyline>
                                                    <line x1="16" y1="13" x2="8" y2="13"></line>
                                                    <line x1="16" y1="17" x2="8" y2="17"></line>
                                                    <polyline points="10 9 9 9 8 9"></polyline>
                                                </svg>
                                            </div>
                                            
                                            {/* Title */}
                                            <h2 style={{ 
                                                color: '#1a1a1a', 
                                                marginBottom: '16px', 
                                                fontSize: '32px', 
                                                fontWeight: '700',
                                                lineHeight: '1.2',
                                                letterSpacing: '-0.5px'
                                            }}>
                                                No Active Orders
                                            </h2>
                                            
                                            {/* Description */}
                                            <p style={{ 
                                                color: '#6b7280', 
                                                fontSize: '17px', 
                                                lineHeight: '1.7', 
                                                marginBottom: '36px',
                                                fontWeight: '500',
                                                maxWidth: '420px',
                                                margin: '0 auto 36px'
                                            }}>
                                                You don't have any active orders at the moment.<br />
                                                Start by listing your NFTs or browse the marketplace!
                                            </p>
                                            
                                            {/* Button */}
                                            <Link to="/">
                                                <button className="btn BtnBlack" style={{
                                                    fontSize: '15px',
                                                    fontWeight: '700',
                                                    padding: '14px 36px',
                                                    borderRadius: '12px',
                                                    transition: 'all 0.3s ease',
                                                    boxShadow: '0 8px 24px rgba(17, 207, 243, 0.35), 0 4px 12px rgba(105, 239, 183, 0.25)',
                                                    letterSpacing: '0.5px'
                                                }}>
                                                    Browse Marketplace
                                                </button>
                                            </Link>
                                        </div>
                                    ) : (
                                        <div>
                                            <div className="orders-grid">
                                                {activeOrderList.map((data, index) => (
                                                    <OrderCard key={data._id || index} order={data} />
                                                ))}
                                            </div>

                                            <LoadMoreSection
                                                hasNextPage={activeOrderPagination.has_next_page}
                                                onLoadMore={loadMoreActiveOrder}
                                                isLoading={isLoadingMore || activeOrderLoading}
                                                loadMoreText="Load More Orders"
                                                endMessage="No more active orders to load"
                                                accentColor="17, 207, 243"
                                            />
                                        </div>
                                    )}
                                </div>

                                <div className="tab-pane fade" id="Owned" role="tabpanel" aria-labelledby="Owned-tab">
                                    {closeOrderError && !closeOrderLoading ? (
                                        <div className="text-center py-5" style={{ maxWidth: '500px', margin: '120px auto', padding: '40px 20px' }}>
                                            {/* Error Icon Container */}
                                            <div style={{
                                                width: '140px',
                                                height: '140px',
                                                margin: '0 auto 32px',
                                                background: 'linear-gradient(135deg, rgba(239, 68, 68, 0.08), rgba(220, 38, 38, 0.08))',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                border: '3px solid rgba(239, 68, 68, 0.2)',
                                                position: 'relative'
                                            }}>
                                                <svg width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#ef4444', filter: 'drop-shadow(0 4px 16px rgba(239, 68, 68, 0.3))' }}>
                                                    <circle cx="12" cy="12" r="10"></circle>
                                                    <line x1="12" y1="8" x2="12" y2="12"></line>
                                                    <line x1="12" y1="16" x2="12.01" y2="16"></line>
                                                </svg>
                                            </div>
                                            
                                            {/* Error Title */}
                                            <h3 style={{ 
                                                color: '#1a1a1a', 
                                                marginBottom: '16px', 
                                                fontSize: '32px', 
                                                fontWeight: '700',
                                                lineHeight: '1.2',
                                                letterSpacing: '-0.5px'
                                            }}>
                                                Unable to Load Orders
                                            </h3>
                                            
                                            {/* Error Message */}
                                            <p style={{ 
                                                color: '#6b7280', 
                                                fontSize: '17px', 
                                                lineHeight: '1.7', 
                                                marginBottom: '0',
                                                fontWeight: '500',
                                                maxWidth: '420px',
                                                margin: '0 auto'
                                            }}>
                                                {'Something went wrong while fetching your closed orders. Please try again later.'}
                                            </p>
                                        </div>
                                    ) : closeOrderLoading && closeOrderList.length === 0 ? (
                                        <div className="orders-grid">
                                            {new Array(6).fill(1).map((_, index) => (
                                                <OrderCardSkeleton key={index} />
                                            ))}
                                        </div>
                                    ) : !closeOrderLoading && closeOrderList.length === 0 ? (
                                        <div className="text-center py-5" style={{ maxWidth: '500px', margin: '120px auto', padding: '40px 20px' }}>
                                            {/* Icon Container */}
                                            <div style={{
                                                width: '140px',
                                                height: '140px',
                                                margin: '0 auto 32px',
                                                background: 'linear-gradient(135deg, rgba(17, 207, 243, 0.1), rgba(105, 239, 183, 0.1))',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                border: '3px solid rgba(17, 207, 243, 0.2)',
                                                position: 'relative',
                                                animation: 'iconFloat 3s ease-in-out infinite'
                                            }}>
                                                <div style={{
                                                    position: 'absolute',
                                                    top: '50%',
                                                    left: '50%',
                                                    transform: 'translate(-50%, -50%)',
                                                    width: '120%',
                                                    height: '120%',
                                                    background: 'radial-gradient(circle, rgba(17, 207, 243, 0.2) 0%, rgba(105, 239, 183, 0.15) 40%, transparent 70%)',
                                                    borderRadius: '50%',
                                                    animation: 'glowPulse 3s ease-in-out infinite'
                                                }}></div>
                                                <svg width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#69efb7', filter: 'drop-shadow(0 4px 16px rgba(105, 239, 183, 0.5))', position: 'relative', zIndex: 1 }}>
                                                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                                                </svg>
                                            </div>
                                            
                                            {/* Title */}
                                            <h2 style={{ 
                                                color: '#1a1a1a', 
                                                marginBottom: '16px', 
                                                fontSize: '32px', 
                                                fontWeight: '700',
                                                lineHeight: '1.2',
                                                letterSpacing: '-0.5px'
                                            }}>
                                                No Closed Orders
                                            </h2>
                                            
                                            {/* Description */}
                                            <p style={{ 
                                                color: '#6b7280', 
                                                fontSize: '17px', 
                                                lineHeight: '1.7', 
                                                marginBottom: '36px',
                                                fontWeight: '500',
                                                maxWidth: '420px',
                                                margin: '0 auto 36px'
                                            }}>
                                                You don't have any closed orders yet.<br />
                                                Completed orders will appear here!
                                            </p>
                                            
                                            {/* Button */}
                                            <Link to="/">
                                                <button className="btn BtnBlack" style={{
                                                    fontSize: '15px',
                                                    fontWeight: '700',
                                                    padding: '14px 36px',
                                                    borderRadius: '12px',
                                                    transition: 'all 0.3s ease',
                                                    boxShadow: '0 8px 24px rgba(17, 207, 243, 0.35), 0 4px 12px rgba(105, 239, 183, 0.25)',
                                                    letterSpacing: '0.5px'
                                                }}>
                                                    Explore NFTs
                                                </button>
                                            </Link>
                                        </div>
                                    ) : (
                                        <div>
                                            <div className="orders-grid">
                                                {closeOrderList.map((data, index) => (
                                                    <OrderCard key={data._id || index} order={data} />
                                                ))}
                                            </div>

                                            <LoadMoreSection
                                                hasNextPage={closeOrderPagination.has_next_page}
                                                onLoadMore={loadMoreCloseOrder}
                                                isLoading={isLoadingMore || closeOrderLoading}
                                                loadMoreText="Load More Orders"
                                                endMessage="No more closed orders to load"
                                                accentColor="105, 239, 183"
                                            />
                                        </div>
                                    )}
                                </div>


                                <div className="tab-pane fade" id="Created" role="tabpanel" aria-labelledby="Created-tab">
                                    {cancelOrderError && !cancelOrderLoading ? (
                                        <div className="text-center py-5" style={{ maxWidth: '500px', margin: '120px auto', padding: '40px 20px' }}>
                                            {/* Error Icon Container */}
                                            <div style={{
                                                width: '140px',
                                                height: '140px',
                                                margin: '0 auto 32px',
                                                background: 'linear-gradient(135deg, rgba(239, 68, 68, 0.08), rgba(220, 38, 38, 0.08))',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                border: '3px solid rgba(239, 68, 68, 0.2)',
                                                position: 'relative'
                                            }}>
                                                <svg width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#ef4444', filter: 'drop-shadow(0 4px 16px rgba(239, 68, 68, 0.3))' }}>
                                                    <circle cx="12" cy="12" r="10"></circle>
                                                    <line x1="12" y1="8" x2="12" y2="12"></line>
                                                    <line x1="12" y1="16" x2="12.01" y2="16"></line>
                                                </svg>
                                            </div>
                                            
                                            {/* Error Title */}
                                            <h3 style={{ 
                                                color: '#1a1a1a', 
                                                marginBottom: '16px', 
                                                fontSize: '32px', 
                                                fontWeight: '700',
                                                lineHeight: '1.2',
                                                letterSpacing: '-0.5px'
                                            }}>
                                                Unable to Load Orders
                                            </h3>
                                            
                                            {/* Error Message */}
                                            <p style={{ 
                                                color: '#6b7280', 
                                                fontSize: '17px', 
                                                lineHeight: '1.7', 
                                                marginBottom: '0',
                                                fontWeight: '500',
                                                maxWidth: '420px',
                                                margin: '0 auto'
                                            }}>
                                                {'Something went wrong while fetching your cancelled orders. Please try again later.'}
                                            </p>
                                        </div>
                                    ) : cancelOrderLoading && cancelOrderList.length === 0 ? (
                                        <div className="orders-grid">
                                            {new Array(6).fill(1).map((_, index) => (
                                                <OrderCardSkeleton key={index} />
                                            ))}
                                        </div>
                                    ) : !cancelOrderLoading && cancelOrderList.length === 0 ? (
                                        <div className="text-center py-5" style={{ maxWidth: '500px', margin: '120px auto', padding: '40px 20px' }}>
                                            {/* Icon Container */}
                                            <div style={{
                                                width: '140px',
                                                height: '140px',
                                                margin: '0 auto 32px',
                                                background: 'linear-gradient(135deg, rgba(17, 207, 243, 0.1), rgba(105, 239, 183, 0.1))',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                border: '3px solid rgba(17, 207, 243, 0.2)',
                                                position: 'relative',
                                                animation: 'iconFloat 3s ease-in-out infinite'
                                            }}>
                                                <div style={{
                                                    position: 'absolute',
                                                    top: '50%',
                                                    left: '50%',
                                                    transform: 'translate(-50%, -50%)',
                                                    width: '120%',
                                                    height: '120%',
                                                    background: 'radial-gradient(circle, rgba(17, 207, 243, 0.2) 0%, rgba(105, 239, 183, 0.15) 40%, transparent 70%)',
                                                    borderRadius: '50%',
                                                    animation: 'glowPulse 3s ease-in-out infinite'
                                                }}></div>
                                                <svg width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#f31717', filter: 'drop-shadow(0 4px 16px rgba(243, 23, 23, 0.4))', position: 'relative', zIndex: 1 }}>
                                                    <circle cx="12" cy="12" r="10"></circle>
                                                    <line x1="15" y1="9" x2="9" y2="15"></line>
                                                    <line x1="9" y1="9" x2="15" y2="15"></line>
                                                </svg>
                                            </div>
                                            
                                            {/* Title */}
                                            <h2 style={{ 
                                                color: '#1a1a1a', 
                                                marginBottom: '16px', 
                                                fontSize: '32px', 
                                                fontWeight: '700',
                                                lineHeight: '1.2',
                                                letterSpacing: '-0.5px'
                                            }}>
                                                No Cancelled Orders
                                            </h2>
                                            
                                            {/* Description */}
                                            <p style={{ 
                                                color: '#6b7280', 
                                                fontSize: '17px', 
                                                lineHeight: '1.7', 
                                                marginBottom: '36px',
                                                fontWeight: '500',
                                                maxWidth: '420px',
                                                margin: '0 auto 36px'
                                            }}>
                                                You don't have any cancelled orders.<br />
                                                Cancelled orders will appear here when you cancel them!
                                            </p>
                                            
                                            {/* Button */}
                                            <Link to="/">
                                                <button className="btn BtnBlack" style={{
                                                    fontSize: '15px',
                                                    fontWeight: '700',
                                                    padding: '14px 36px',
                                                    borderRadius: '12px',
                                                    transition: 'all 0.3s ease',
                                                    boxShadow: '0 8px 24px rgba(17, 207, 243, 0.35), 0 4px 12px rgba(105, 239, 183, 0.25)',
                                                    letterSpacing: '0.5px'
                                                }}>
                                                    View Marketplace
                                                </button>
                                            </Link>
                                        </div>
                                    ) : (
                                        <div>
                                            <div className="orders-grid">
                                                {cancelOrderList.map((data, index) => (
                                                    <OrderCard key={data._id || index} order={data} />
                                                ))}
                                            </div>

                                            <LoadMoreSection
                                                hasNextPage={cancelOrderPagination.has_next_page}
                                                onLoadMore={loadMoreCancelOrder}
                                                isLoading={isLoadingMore || cancelOrderLoading}
                                                loadMoreText="Load More Orders"
                                                endMessage="No more cancelled orders to load"
                                                accentColor="243, 23, 23"
                                            />
                                        </div>
                                    )}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <NotLoggedInRedirection />
        </main>
    );
}
